
import { createLogger } from "@/utils/logger";

const logger = createLogger('location:storage');

/**
 * Helper function to safely get items from storage with optional parsing
 */
export const getFromStorage = <T,>(key: string, parser?: (val: string) => T): T | null => {
  try {
    const value = localStorage.getItem(key);
    if (value === null) return null;
    return parser ? parser(value) : value as unknown as T;
  } catch (err) {
    logger.warn(`Failed to get ${key} from localStorage:`, err);
    return null;
  }
};

/**
 * Helper function to safely set items to storage with serialization
 */
export const setToStorage = (key: string, value: any): void => {
  try {
    if (value === null) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
    }
  } catch (err) {
    logger.warn(`Failed to set ${key} in localStorage:`, err);
  }
};
